import Layout from "@/views/Layout/index.vue";
let addRoutes = [];
export default addRoutes = [
  {
    path: "/regionHome",
    name: "RegionHome",
    redirect: "/regionHomeDetail",
    meta: {
      title: "首页",
      icon: "el-icon-s-home"
    },
    component: "layout",
    children: [
      {
        path: "/regionHomeDetail",
        component: "/otcCommon/homePage/index.vue",
        // hidden: true,
        meta: {
          title: "首页"
        }
      }
    ]
  },
  {
    path: "/regionLargeScreen",
    name: "RegionLargeScreen",
    redirect: "/regionLargeScreenDetail",
    meta: {
      title: "大数据",
      icon: "el-icon-s-marketing"
    },
    component: "layout",
    children: [
      {
        path: "/regionLargeScreenDetail",
        component: "/otcCommon/largeScreen/index.vue",
        // hidden: true,
        meta: {
          title: "大数据"
        }
      }
    ]
  },
  {
    path: "/patientManage",
    name: "PatientManage",
    redirect: "/patientManageDetail",
    meta: {
      title: "患者管理",
      icon: "el-icon-user-solid"
    },
    component: "layout",
    children: [
      {
        path: "/patientManageDetail",
        component: "/otcCommon/patientManage/index.vue",
        // hidden: true,
        meta: {
          title: "患者管理"
        }
      },
      {
        path: "/patientDetails",
        component: "/otcCommon/patientManage/patientDetails.vue",
        hidden: true,
        meta: {
          title: "患者详情",
          guidePath: true,
          jumpPath: "/patientManageDetail"
        }
      }
    ]
  },
  {
    path: "/dataManage",
    // hidden: false,
    name: "DataManage",
    redirect: "/sugarDataManage",
    meta: {
      title: "数据管理",
      icon: "el-icon-s-platform"
    },
    component: "layout",
    children: [
      {
        path: "/sugarDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "血糖数据",
          type: "sugar"
        }
      },

      {
        path: "/pressureDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "血压数据",
          type: "pressure"
        }
      },
      {
        path: "/fatDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "血脂数据",
          type: "fat"
        }
      },
      {
        path: "/heartDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "心电数据",
          type: "heart"
        }
      },
      {
        path: "/ketoneDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "血酮数据",
          type: "ketone"
        }
      },
      {
        path: "/uricAcidDataManage",
        component: "/otcCommon/dataManage/index.vue",
        // hidden: true,
        meta: {
          title: "尿酸数据",
          type: "uricAcid"
        }
      }
    ]
  },
  {
    path: "/areaMange",
    // hidden: false,
    name: "AreaManage",
    redirect: "/areaManageDetail",
    meta: {
      title: "片区管理",
      icon: "el-icon-s-grid"
    },
    component: "layout",
    children: [
      {
        path: "/areaManageDetail",
        component: "/otcCommon/areaMange/index.vue",
        // hidden: true,
        meta: {
          title: "片区管理"
        }
      }
    ]
  },
  {
    path: "/pharmacyMange",
    // hidden: false,
    name: "PharmacyMange",
    redirect: "/pharmacyMangeDetail",
    meta: {
      title: "药店管理",
      icon: "el-icon-s-shop"
    },
    component: "layout",
    children: [
      {
        path: "/pharmacyMangeDetail",
        component: "/otcCommon/pharmacyMange/index.vue",
        // hidden: true,
        meta: {
          title: "药店管理"
        }
      }
    ]
  },

  {
    path: "/testStrip",
    // hidden: false,
    name: "TestStrip",
    redirect: "/testStripDetail",
    meta: {
      title: "试条用量统计",
      icon: "el-icon-s-order"
      // icon: "https://img-home.csdnimg.cn/images/20220107104621.png"
    },
    component: "layout",
    children: [
      {
        path: "/testStripDetail",
        component: "/otcCommon/testStrip/index.vue",
        // hidden: true,
        meta: {
          title: "试条用量统计"
        }
      }
    ]
  }
];
